import React from 'react';

export default function ArrowWhiteUp() {
    return (
        <div className="btn-arrow">
            <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="arrow-up" transform="translate(0.863667, 0.136333)" fill="#FFFFFF" fillRule="nonzero">
                        <path d="M5.70032265,-0.13633335 L8.08844495,-0.13633335 L12.1336672,5.98532035 L8.08569565,12.1336672 L5.70032265,12.1336672 L9.74728125,5.98762895 L5.70032265,-0.13633335 Z M0.13633335,-0.13633335 L2.52431095,-0.13633335 L6.56982255,5.98532035 L2.52127225,12.1336672 L0.13633335,12.1336672 L4.18329195,5.98762895 L0.13633335,-0.13633335 Z" id="Fill-1" transform="translate(6.135000, 5.998667) rotate(-90.000000) translate(-6.135000, -5.998667) "></path>
                    </g>
                </g>
            </svg>
        </div>
    );
}